export type VgaFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type VgaFilterGroup = {
  id: string;
  label: string;
  options: VgaFilterOption[];
};

export const vgaFilterGroups: VgaFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu VGA',
    options: [
      { value: 'asus', label: 'ASUS', keywords: ['asus'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'gigabyte', label: 'GIGABYTE', keywords: ['gigabyte'] },
      { value: 'zotac', label: 'ZOTAC', keywords: ['zotac'] },
      { value: 'inno3d', label: 'INNO3D', keywords: ['inno3d'] },
      { value: 'galax', label: 'GALAX', keywords: ['galax'] },
      { value: 'colorful', label: 'COLORFUL', keywords: ['colorful'] },
      { value: 'palit', label: 'PALIT', keywords: ['palit'] },
      { value: 'sapphire', label: 'SAPPHIRE', keywords: ['sapphire'] },
      { value: 'asrock', label: 'ASROCK', keywords: ['asrock'] },
      { value: 'pny', label: 'PNY', keywords: ['pny'] },
      { value: 'leadtek', label: 'LEADTEK', keywords: ['leadtek'] },
    ],
  },
  {
    id: 'vram',
    label: 'Bộ nhớ (VRAM)',
    options: [
      { value: '2gb', label: '2GB', keywords: ['2gb', '2 gb'] },
      { value: '4gb', label: '4GB', keywords: ['4gb', '4 gb'] },
      { value: '6gb', label: '6GB', keywords: ['6gb', '6 gb'] },
      { value: '8gb', label: '8GB', keywords: ['8gb', '8 gb'] },
      { value: '12gb', label: '12GB', keywords: ['12gb', '12 gb'] },
      { value: '16gb', label: '16GB', keywords: ['16gb', '16 gb'] },
      { value: '24gb', label: '24GB', keywords: ['24gb', '24 gb'] },
    ],
  },
  {
    id: 'gpu-vendor',
    label: 'Hãng GPU',
    options: [
      {
        value: 'nvidia',
        label: 'NVIDIA',
        keywords: ['nvidia', 'geforce', 'rtx', 'gtx', 'gt series'],
      },
      { value: 'amd', label: 'AMD', keywords: ['amd', 'radeon', 'rx'] },
      { value: 'intel', label: 'Intel', keywords: ['intel', 'arc'] },
    ],
  },
  {
    id: 'nvidia-series',
    label: 'NVIDIA',
    options: [
      { value: 'gt-series', label: 'GT Series', keywords: ['gt '] },
      { value: 'gtx-series', label: 'GTX Series', keywords: ['gtx'] },
      { value: 'rtx-20', label: 'RTX 20 Series', keywords: ['rtx 20', 'rtx20', '20 series'] },
      { value: 'rtx-30', label: 'RTX 30 Series', keywords: ['rtx 30', 'rtx30', '30 series'] },
      { value: 'rtx-40', label: 'RTX 40 Series', keywords: ['rtx 40', 'rtx40', '40 series'] },
      { value: 'rtx-50', label: 'RTX 50 Series', keywords: ['rtx 50', 'rtx50', '50 series'] },
    ],
  },
  {
    id: 'amd-series',
    label: 'AMD',
    options: [
      { value: 'rx-500', label: 'RX 500 Series', keywords: ['rx 5', 'rx500', 'rx 500'] },
      { value: 'rx-6000', label: 'RX 6000 Series', keywords: ['rx 6', 'rx6000', 'rx 6000'] },
      { value: 'rx-7000', label: 'RX 7000 Series', keywords: ['rx 7', 'rx7000', 'rx 7000'] },
      { value: 'rx-9000', label: 'RX 9000 Series', keywords: ['rx 9', 'rx9000', 'rx 9000'] },
    ],
  },
  {
    id: 'workstation',
    label: 'Workstation',
    options: [
      { value: 'quadro', label: 'Quadro Series', keywords: ['quadro'] },
      { value: 't-series', label: 'T Series', keywords: ['t series', ' t'] },
      { value: 'rtx-a', label: 'RTX A Series', keywords: ['rtx a', 'rtx-a'] },
      { value: 'rtx-ada', label: 'RTX Ada Series', keywords: ['ada', 'rtx ada'] },
    ],
  },
];
